import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Main from "../components/Main";
import FooterSection from "../components/FooterSection";
import NumberCount from "../components/NumberCount";
import TopNav from "../components/TopNav";
import MsportModal from "../components/MsportModal";
// import BottomNavBar from "../components/BottomNavBar";
import VipRequired from "../components/VipRequired";
import TipsterAdvice from "../components/TipstarAdvice";
import InstallAppBtn from "../components/buttons/InstallAppBtn";

export default function Home() {
  const [showModal, setShowModal] = React.useState(true);
  return (
    <div>
      <InstallAppBtn />
      {showModal && <MsportModal setShowModal={setShowModal} />}
      <TopNav />
      <Header />
      <Hero />
      <VipRequired />
      <Main />
      <TipsterAdvice />
      <NumberCount />
      <FooterSection />
      {/* <BottomNavBar /> */}

    </div>
  );
}
  